import React from "react";
import { GlassCard, PageTitle, LuxuryButton } from "@/components/lux";
import { API } from "@/lib/api";
import { FileBarChart, Download } from "lucide-react";

const REPORTS = [
  ["users", "User Report", "All members with status, rank and package"],
  ["deposits", "Deposit Report", "All deposit requests and their statuses"],
  ["withdrawals", "Withdrawal Report", "Payout requests, amounts and statuses"],
  ["income", "Income Report", "Every credited income transaction"],
];

export default function AdminReports() {
  const download = async (report) => {
    const token = localStorage.getItem("token");
    const res = await fetch(`${API}/admin/reports/${report}`, { headers: { Authorization: `Bearer ${token}` } });
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a"); a.href = url; a.download = `${report}.csv`; a.click(); URL.revokeObjectURL(url);
  };
  return (
    <div className="space-y-6">
      <PageTitle title="Reports" subtitle="Export CSV / Excel-ready data" />
      <div className="grid gap-4 sm:grid-cols-2">
        {REPORTS.map(([key, title, desc]) => (
          <GlassCard key={key} hover className="flex items-center justify-between p-6">
            <div className="flex items-start gap-3">
              <div className="grid h-11 w-11 place-items-center rounded-xl gold-border bg-white/5"><FileBarChart size={20} className="text-[var(--gold)]" /></div>
              <div><p className="font-medium text-white">{title}</p><p className="text-xs text-[var(--text-dim)]">{desc}</p></div>
            </div>
            <LuxuryButton size="sm" onClick={() => download(key)} data-testid={`report-${key}`}><Download size={14} className="mr-1 inline" /> CSV</LuxuryButton>
          </GlassCard>
        ))}
      </div>
    </div>
  );
}
